import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Icon } from '@haldor/ui';
import './WizardTimeLine.scss';

var WizardTimeLine = /*#__PURE__*/function (_Component) {
  _inherits(WizardTimeLine, _Component);

  var _super = _createSuper(WizardTimeLine);

  function WizardTimeLine() {
    _classCallCheck(this, WizardTimeLine);

    return _super.apply(this, arguments);
  }

  _createClass(WizardTimeLine, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "timeline-container"
      }, this.props.children.map(function (child, i) {
        if (child.props.name == null) return null;
        var classname = 'timeline-item';

        if (_this.props.currentPage > i) {
          classname += ' active';
        }

        if (_this.props.currentPage == i) {
          classname += ' current';
        }

        return /*#__PURE__*/React.createElement("div", {
          className: classname,
          key: i,
          onClick: function onClick() {
            _this.props.goToPage(i);
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: "timeline-header"
        }, /*#__PURE__*/React.createElement("div", {
          className: "timeline-dot"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "Check"
        })), /*#__PURE__*/React.createElement("span", {
          className: "timeline-label"
        }, child.props.name)));
      }));
    }
  }]);

  return WizardTimeLine;
}(Component);

export default WizardTimeLine;